export const ACTION_INIT_EXCHANGE_RATES_FOR_EUR__REQUEST = 'ACTION_INIT_EXCHANGE_RATES_FOR_EUR__REQUEST';
export const ACTION_INIT_EXCHANGE_RATES_FOR_EUR__SUCCESS = 'ACTION_INIT_EXCHANGE_RATES_FOR_EUR__SUCCESS';
export const ACTION_INIT_EXCHANGE_RATES_FOR_EUR__FAIL = 'ACTION_INIT_EXCHANGE_RATES_FOR_EUR__FAIL';
